import moment from "moment";
import { useEffect } from "react";
import { Box, useDisclosure } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";

import { usePaginationApi } from "../../shared/hooks";
import usePagination from "../../features/admin/usePagination";
import { Header } from "../../shared/components";
import { Table } from "../../features/admin/components";

function ViewSubscribeUsersPage() {
  const { getWithPagination } = usePaginationApi();

  const { onOpen } = useDisclosure();

  const [pagination, setPagination] = usePagination();
  const columnHelper = createColumnHelper<any>();

  const { isLoading, data } = useQuery({
    queryKey: ["subscribe-user-list", pagination],
    queryFn: async () => {
      const response: any = await getWithPagination("MATCHING_PROFILE_SERVICE", "/api/admin/subscribe-user-list", {
        perpage: pagination.perPage,
        page: pagination.currentPage,
        search: pagination.searchTerm,
      });
console.log(response);
      if (!response?.status) {
        throw new Error(response?.message);
      }

      return {
        data: response?.data.data,
      };
    },
    keepPreviousData: true,
  });

  useEffect(() => {
    if (data) {
      setPagination({
        ...pagination,
        currentPage: data?.data?.current_page ?? 1,
        perPage: pagination.perPage ?? 20,
        total: data?.data?.total_items ?? 0,
        totalPages: data?.data?.total_pages ?? 0,
      });
    }
  }, [data]);

  const columns = [
    columnHelper.accessor("SN", {
      header: () => <span>SN</span>,
      size: 50,
      cell: (info: any) => {
        return (
          <span>
            {info.row.index + (pagination?.currentPage - 1) * pagination?.perPage + 1}
          </span>
        );
      },
    }),

    columnHelper.accessor("full_name", {
      id: "full_name",
      header: () => <span>Name</span>,
      size: 200,
      cell: (info: any) => {
        const full_name = info?.row?.original?.user_profile.full_name || "";
        const capitalized =
          full_name.charAt(0).toUpperCase() + full_name.slice(1);
        return <span>{capitalized}</span>;
      },
    }),
    columnHelper.accessor("email", {
      id: "email",
      header: () => <span>Email</span>,
      size: 200,
      cell: (info: any) => {
        return <span>{info?.row?.original?.user_profile.email}</span>;
      },
    }),
    columnHelper.accessor("updated_at", {
      id: "updated_at",
      header: () => <span>{"Subscribe At"}</span>,
      size: 200,
      cell: (info: any) => {
        return (
          <span>
            {(info?.row?.original?.updated_at &&
              moment(
                info?.row?.original?.updated_at,
                "YYYY-MM-DDTHH:mmZ"
              ).format("MMMM D, YYYY")) ||
              ""}
          </span>
        );
      },
    }),
    columnHelper.accessor("Subscription", {
      id: "Subscription",
      header: () => <span>{"Subscription"}</span>,
      size: 200,
      cell: (info: any) => {
        return <span>{info?.row?.original?.subscription_type.name}</span>;
      },
    }),
    columnHelper.accessor("payment_logs", {
      id: "payment_logs",
      header: () => <span>{"Payment Method"}</span>,
      size: 200,
      cell: (info: any) => {
        let output;
        let inAppPurchaseRegex=/^[0-9]+$/
        let paymentIntentId=info?.row?.original?.payment_logs[0]?.payment_intent_id
        if (paymentIntentId) {
          if(inAppPurchaseRegex.test(paymentIntentId.toString())){
            output="In-App-Purchase"
          }else{
            output="Stripe"
          }

        }else{
          output='No payment intent found'
        }
        return (
          <span>{output}</span>
        );
      },
    }),
    columnHelper.accessor("type", {
      id: "type",
      header: () => <span>{"Type"}</span>,
      size: 200,
      cell: (info: any) => {
        return <span>{info?.row?.original?.subscription_type.type}</span>;
      },
    }),
  ];

  return (
    <Box>
      <Header
        buttonIcon={null}
        header={"List of subscribe user"}
        buttonText={undefined}
        handleOpen={onOpen}
      />
      <Table
        title="List of Subscribed Users"
        columns={columns}
        rowData={data?.data?.data_list ?? []}
        pagination={pagination}
        setPagination={setPagination}
        loading={isLoading}
      />
    </Box>
  );
}

export default ViewSubscribeUsersPage;
